import type { ReactNode } from 'react';
import { Checkbox, Table, TableTbody, TableTd, TableTh, TableThead, TableTr } from '@customerio/pluma-components/react';
import type { Relationship } from '@customerio/hydra-ui-api';
import { RelationshipRow, type RelationshipRowModel } from './relationship-row';

/** Checkbox, person, relationship attributes, created_at, view. */
const COLUMN_COUNT = 5;

export type RelationshipsTableBodyProps = {
  rows: RelationshipRowModel[];
  personSingular: string;
  canSelect: boolean;
  isPageSelected: boolean;
  isSelectionIndeterminate: boolean;
  onSelectPage: (checked: boolean) => void;
  onSelectRow: (relationship: Relationship, index: number, checked: boolean) => void;
  onViewRelationship: ((relationship: Relationship) => void) | undefined;
  emptyState: ReactNode;
};

export function RelationshipsTableBody({
  rows,
  personSingular,
  canSelect,
  isPageSelected,
  isSelectionIndeterminate,
  onSelectPage,
  onSelectRow,
  onViewRelationship,
  emptyState,
}: RelationshipsTableBodyProps) {
  return (
    <Table caption="List of relationships" layout="fixed">
      <TableThead>
        <TableTr>
          <TableTh py="0" style={{ width: '42px' }}>
            <Checkbox
              name="check_all_on_page"
              isDisabled={!canSelect}
              isChecked={isPageSelected}
              isIndeterminate={isSelectionIndeterminate}
              onCheckedChange={onSelectPage}
              ariaLabel="Select all relationships"
              data-test-select-all-relationships
            />
          </TableTh>
          <TableTh>{personSingular}</TableTh>
          <TableTh data-test-attributes-column>Relationship attributes</TableTh>
          <TableTh textAlign="right">created_at</TableTh>
          <TableTh textAlign="right" style={{ width: '64px' }} />
        </TableTr>
      </TableThead>
      <TableTbody>
        {rows.length === 0 ? (
          <TableTr>
            <TableTd colSpan={COLUMN_COUNT}>{emptyState}</TableTd>
          </TableTr>
        ) : (
          rows.map((row) => (
            <RelationshipRow
              key={row.key}
              row={row}
              canSelect={canSelect}
              onSelectedChange={(checked) => onSelectRow(row.relationship, row.index, checked)}
              onView={onViewRelationship == null ? undefined : () => onViewRelationship(row.relationship)}
            />
          ))
        )}
      </TableTbody>
    </Table>
  );
}
